//
// CardText
//
import classNames from 'classnames';
import PropTypes from 'prop-types';

const CardText = function CardText(props) {
  const {
    children,
    className,
    disabled = false,
  } = props;

  return (
    <span
      className={classNames(
        {
          'opacity-50': disabled,
        },
        className,
      )}
    >
      {children}
    </span>
  );
};

CardText.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CardText;
